import {Pipe, PipeTransform} from "@angular/core";
import {TariffServiceStatus} from "../../model/tariffServiceStatus";

@Pipe({name: 'tariffServiceStatusType'})
export class TariffServiceStatusPipe implements PipeTransform {
    transform(value: any) {
        return TariffServiceStatus[value];
    }
}
